import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-2020"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.727 14.144a1.272 1.272 0 1 0 2.546 0C9.273 13.44 8 11.598 8 11.598s-1.273 1.842-1.273 2.546zM2.545 12.68a1.272 1.272 0 1 0 2.546 0c0-.704-1.273-2.546-1.273-2.546s-1.273 1.843-1.273 2.546zm9.637-2.546s-1.273 1.842-1.273 2.546a1.272 1.272 0 1 0 2.546 0c0-.703-1.273-2.546-1.273-2.546z",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M2.554 9.267h10.891a.61.61 0 0 0 .492-.968L8.492.833a.61.61 0 0 0-.984 0L2.062 8.299a.61.61 0 0 0 .492.968zM8 7.477a.446.446 0 1 1 0-.893.446.446 0 0 1 0 .893zm0-3.691c.336 0 .595.297.548.63L8.302 6.18h-.604l-.247-1.763A.555.555 0 0 1 8 3.786z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }